import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {Order} from '../classes/order';
import {orderType} from '../../shared/constantes';
import {FormBuilder} from '@angular/forms';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class RmDraftService {
    public continueNavigation: Subject<boolean> = new Subject<boolean>();
    private updateDraftSignal: BehaviorSubject<boolean>;
    private mobilePackForms: BehaviorSubject<any>;

    constructor(
        private formBuilder: FormBuilder
    ) {
        this.updateDraftSignal = new BehaviorSubject<boolean>(false);
        this.mobilePackForms = new BehaviorSubject<any>([]);
    }

    isPersistableOrder(order: Order, ratesMobile) {
        return order.draft && (
            (order.broadband && order.broadband.rate_package_id && order.broadband.rate_package_id !== '') ||
            // (order.mobiles && order.mobiles.length) ||
            (ratesMobile && ratesMobile.length)
        );
    }

    updateDraft(val: boolean) {
        this.updateDraftSignal.next(val);
    }

    getUpdateDraft() {
        return this.updateDraftSignal.asObservable();
    }

    setMobilePackForms(data) {
        this.mobilePackForms.next(data);
    }

    getMobilePackForms() {
        return this.mobilePackForms.asObservable();
    }

    getUserDataFromOrder(order) {
        const user = {
            doctype: order.customer_document_type != null ? order.customer_document_type.document_type_id : null,
            doc: order.customer_document,
            country: order.customer_nationality_id != null ? order.customer_nationality_id : null,
            firstName: order.customer_name,
            surname1: order.customer_last_name,
            surname2: order.customer_second_last_name,
            birthday: order.customer_birth_date,
            sex: order.customer_gender,
            company: order.customer_company_name,
            tipoVia: null,
            nombreVia: null,
            numero: null,
            planta: null,
            puerta: null,
            escalera: null,
            codigoPostal: null,
            localidad: null,
            provincia: null,
            phone: order.customer_phone_number,
            email: order.customer_email,
            bank_account: order.iban,
            account_doctype: order.customer_document_type?.document_type_id,
            account_doc: order.customer_document,
            account_country: order.customer_nationality_id,
            account_firstName: order.customer_name,
            account_surname1: order.customer_last_name,
            account_surname2: order.customer_second_last_name,
            account_company: '',
        };

        if (order.payer != null) {
            user.account_doctype = order.payer.document_type.document_type_id;
            user.account_doc = order.payer.document;
            user.account_country = '';
            user.account_firstName = order.payer.name;
            user.account_surname1 = order.payer.last_name;
            user.account_surname2 = order.payer.second_last_name;
            user.account_company = '';
        }

        if (order.addresses.length > 0) {
            const contactAddress = order.addresses.filter(address => {
                return address.type === 'billing';
            });

            if (contactAddress.length > 0) {
                user.tipoVia = contactAddress[0].street_type;
                user.nombreVia = contactAddress[0].street_name;
                user.numero = contactAddress[0].street_number;
                user.planta = contactAddress[0].floor_number;
                user.puerta = contactAddress[0].apartment_number;
                user.escalera = contactAddress[0].staircase_number;
                user.codigoPostal = contactAddress[0].post_code;
                user.localidad = contactAddress[0].city;
                user.provincia = contactAddress[0].province;
                // user.additional_info = contactAddress[0].additional_info;
            }
        }

        return user;
    }

    isNotEmpty(value): boolean {
        return value != null && value != '';
    }

    getNormalizador(broadband: any) {
        return {
            tipoViaNormaliza: broadband.street_type,
            nombreViaNormaliza: broadband.street_type + ' ' + broadband.street_name,
            numeroNormaliza: broadband.street_number,
            codigoPostalNormaliza: broadband.post_code,
            localidadNormaliza: broadband.city,
            provinciaNormaliza: broadband.province,
        };
    }

    getCobertura(broadband: any) {
        return {
            localidadCobertura: broadband.city,
            direccionesCobertura: broadband.street_name,
            tipoViaCobertura: broadband.street_type,
            nombreViaCobertura: broadband.street_name,
            numeroCobertura: broadband.street_number,
            provinciaCobertura: broadband.province,
            codigoPostalCobertura: broadband.post_code,
            plantaCobertura: broadband.floor_number,
            bisCobertura: '',
            bloqueCobertura: '',
            portalCobertura: '',
            escaleraCobertura: broadband.staircase_number,
            tipoPuertaCobertura: '',
            puertaCobertura: broadband.apartment_number,
            resultadoConsultaCobertura: {
                cimaArvatoCode: broadband.arvato_code,
                cimaGescalCode: broadband.gescal_code,
            }
        };
    }

    getMobilePack(item: any) {
        return {
            type_operation: !item.portability ? 'registration' : 'portability',
            rate: this.getRate(item.rate),
            portability_phone: item.msisdn,
            portability_operator: item.service_provider != null ? item.service_provider.service_provider_id : '',
            portability_type_client: item.old_contract_type,
            portability_iccid: item.old_iccid,
            portability_client: '',
            // portability_date: item.processing_date != null ? moment(item.processing_date).format('YYYY-MM-DD') : '',
            portability_date: '',
            iccid: item.new_iccid,
            terminal: '',
            terminal_payment_type: '',
            terminal_insurance: '',
            stepper_index: '',
            sponsor: item.sponsor,
        };
    }

    getPath(type: string) {
        let path = '';
        switch (type) {
            case orderType.BROADBAND:
                path = '/republica-movil/solo-fibra';
                break;
            case orderType.MOBILE:
                path = '/republica-movil/solo-movil';
                break;
            default:
                path = '/republica-movil/convergente';
                break;
        }
        return path;
    }

    camelToSnake(key: string) {
        return key.replace(/([A-Z])/g, '_$1').toLowerCase();
    }

    snakeToCamel(key: string) {
        key = key.toLowerCase();
        return key.replace(/([-_][a-z])/ig, ($1) => {
            return $1.toUpperCase()
                .replace('-', '')
                .replace('_', '');
        });
    }

    getRate(rate: any) {
        if (rate) {
            rate.contract_type = rate.payment_type === 'post' ? 'postpaid' : 'prepaid';
            return this.keysToCamel(rate);
        }
        return rate;
    }

    keysToCamel(object) {
        const newObject: any = {};

        Object.entries(object).forEach(([key, val]) => {
            if (val != null && parseFloat(val.toString()) > 0) {
                val = parseFloat(val.toString());
            }

            newObject[this.snakeToCamel(key)] = val;
        });

        return newObject;
    }
}
